import { useEffect, useState } from 'react';
import { addPlan, cardReset, resetPlanPayInfo } from '../../store/actions';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
//ui-cmd-2
const StripeProvider = (stripeApiKey) => {
    const [stripe, setStripe] = useState(null);

    const dispatch = useDispatch();

    const BillSetState = state => state.BillSet;
    const BillSetProperties = createSelector(BillSetState, UserBillSet => ({
        cardResponse: UserBillSet.cardResponse,
        billAddress: UserBillSet.billAddress
    }))


    const {
        cardResponse,
        billAddress
    } = useSelector(BillSetProperties);

    const PlanState = state => state.Plan
    const PlanProperties = createSelector(PlanState, Plan => ({
        plan: Plan.plan,
        planAddLoading: Plan.planAddLoading,
        payInfo: Plan.payInfo,
        planAdded: Plan.planAdded
    }))
    const {
        plan, planAddLoading, payInfo, planAdded
    } = useSelector(PlanProperties);

    useEffect(() => {
        if (cardResponse?.company?.is_new && !planAddLoading && !planAdded && billAddress) {
            dispatch(addPlan({ plan_id: "" }))
        }
    }, [cardResponse?.company?.is_new, planAddLoading, planAdded, billAddress])


    useEffect(() => {
        const confirmPayment = async () => {
            if (payInfo) {
                try {
                    let confirm;
                    if (!payInfo.setup && payInfo.clientSecret) {
                        confirm = await stripe.confirmCardPayment(payInfo.clientSecret);
                    }
                    if (payInfo.setup && payInfo.clientSecret) {
                        confirm = await stripe.confirmSetup({
                            clientSecret: payInfo.clientSecret,
                            redirect: "if_required",
                        });
                    }

                } catch (error) {
                    // console.error('Error confirming payment:', error);
                }
                finally {
                    dispatch(resetPlanPayInfo())
                    dispatch(cardReset())
                }
            }
        };
        confirmPayment();


    }, [payInfo]);

    useEffect(() => {
        const scriptId = 'stripe-js';
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = 'https://js.stripe.com/v3/';
            script.async = true;
            script.onload = () => {
                const stripeInstance = window.Stripe(stripeApiKey);
                setStripe(stripeInstance);
            };
            document.body.appendChild(script);
        } else {
            const stripeInstance = window.Stripe(stripeApiKey);
            setStripe(stripeInstance);
        }

        return () => {
            const script = document.getElementById(scriptId);
            if (script) {
                document.body.removeChild(script);
            }
            setStripe(null);
        };
    }, [stripeApiKey]);

    return stripe;
};

export default StripeProvider;
